import { UseFormRegister, FieldErrors } from 'react-hook-form'
import { Textarea, Button, Input } from "@city-sage/aurum-avis-labs-components"
import { StopFormValues } from "../types/createStopTypes"

interface DescriptionSectionProps {
  register: UseFormRegister<StopFormValues>
  errors: FieldErrors<StopFormValues>
  onOpenMarkupEditor?: () => void
  onOpenHighlightMarkupEditor?: () => void
}

export function DescriptionSection({ register, errors, onOpenMarkupEditor, onOpenHighlightMarkupEditor }: DescriptionSectionProps) {
  return (
    <div className="bg-white mt-2 p-4">
      <div className="space-y-4">
        <div>
          <div className="flex items-center justify-between mb-1">
            <h2 className="font-semibold">Highlight</h2>
            {onOpenHighlightMarkupEditor && (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={onOpenHighlightMarkupEditor}
                className="text-xs underline"
              >
                Markup Editor
              </Button>
            )}
          </div>
          <p className="text-sm text-gray-600">A short highlight or key feature of this stop</p>
        </div>
        
        <div className="space-y-2">
          <Input
            id="highlight"
            placeholder="What makes this stop special? (e.g., 'Best view of the city')"
            className="text-sm"
            {...register('highlight')}
          />
          {errors.highlight && (
            <p className="text-xs text-red-600">{String(errors.highlight?.message || '')}</p>
          )}
        </div>

        <div>
          <div className="flex items-center justify-between mb-1">
            <h2 className="font-semibold">Description</h2>
            {onOpenMarkupEditor && (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={onOpenMarkupEditor}
                className="text-xs underline"
              >
                Markup Editor
              </Button>
            )}
          </div>
          <p className="text-sm text-gray-600">Add notes about this stop</p>
        </div>
        
        <div className="space-y-2">
          <Textarea
            id="description"
            placeholder="Describe what you'll do here, what makes this place special, or any notes for your visit..."
            className="min-h-[100px] text-sm resize-none"
            {...register('description')}
          />
          {errors.description && (
            <p className="text-xs text-red-600">{String(errors.description?.message || '')}</p>
          )}
        </div>
      </div>
    </div>
  )
} 